import React, { FC, Fragment } from 'react';
import { Order } from 'models/order';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import TruckIcon from 'components/shared/truck-icon-button/truck-icon.component';
import TruckIconButton from 'components/shared/truck-icon-button/truck-icon-button.component';
import { currentUserVar } from 'apollo/reactive-variables/user';
import { permissions } from 'utils/permission';
import { OrderItemEvent, OrderItemEventType } from 'models/order-item-events';
import { Box } from '@mui/system';

type IconAreaTruckButtonProps = {
    order: Order;
    onOrderItemEvent?: (event: OrderItemEvent) => void;
};
const IconAreaTruckButton: FC<IconAreaTruckButtonProps> = ({ order, onOrderItemEvent }: IconAreaTruckButtonProps) => {
    const currentUser = currentUserVar();

    return (
        <Fragment>
            {order.shouldShowTruckButton ? (
                <Fragment>
                    {permissions.isLabTechnician(currentUser.type) &&
                    !permissions.isExternalTechnician(currentUser.role) ? (
                        <Box sx={{ marginTop: '-5px' }}>
                            <TruckIconButton
                                order={order}
                                onDenthubTransportToggle={(order) => {
                                    if (onOrderItemEvent) {
                                        onOrderItemEvent({
                                            order: order,
                                            eventType: OrderItemEventType.TOGGLE_TRUCK_ICON,
                                        });
                                    }
                                }}
                            />
                        </Box>
                    ) : (
                        <TruckIcon isRequestHandled={order.deliveryDetails.isLabHandleRequest} />
                    )}
                </Fragment>
            ) : (
                <LocalShippingOutlinedIcon sx={{ color: '#f2f2f2' }} />
            )}
        </Fragment>
    );
};

export default IconAreaTruckButton;
